import { IntlShape } from 'react-intl';
import { Translations } from './message.constants';
import { Messages } from './message.models';
import { LANGUAGE_KEY } from './language.constants';

export const translateMessages = (messagesKeys: LANGUAGE_KEY[], intl: IntlShape): Messages => {
  return messagesKeys.reduce((messages, messagesKey) => {
    return {
      ...messages,
      [messagesKey]: intl.formatMessage(Translations[messagesKey]),
    };
  }, {});
};
